const VERSION = '2.17.2';
module.exports = VERSION;



// WEBPACK FOOTER //
// ./src/version.js